import { render, staticRenderFns } from "./hareketler.vue?vue&type=template&id=33a8926a&scoped=true&"
import script from "./hareketler.vue?vue&type=script&lang=js&"
export * from "./hareketler.vue?vue&type=script&lang=js&"
import style0 from "./hareketler.vue?vue&type=style&index=0&id=33a8926a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8926a",
  null
  
)

export default component.exports